import { isDevMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { Store } from "@ngrx/store";

import { AppBrowserModule } from "./app/app.browser.module";

declare global {
  interface Window {
    store?: Store;
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppBrowserModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .then((moduleRef) => {
    if (isDevMode()) {
      try {
        const store = moduleRef.injector.get(Store);
        window.store = store;
        // eslint-disable-next-line no-console
        console.log("[dev] NgRx store exposed as window.store");
      } catch (e: unknown) {
        // eslint-disable-next-line no-console
        console.warn("[dev] Unable to expose NgRx Store on window", e);
      }
    }
  })
  .catch((err: unknown) => {
    // eslint-disable-next-line no-console
    console.error(err);
  });
